import TurndownService from 'turndown';

export function getMarkdownFromQuill(quillRef) {
	const html = quillRef.current.getSemanticHTML();
	const markdown = new TurndownService({
		headingStyle: 'atx',
		emDelimiter: '*',
	}).turndown(html);
	return markdown;
}
